<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
	*{
		box-sizing: border-box;
	}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
  
  width: 100%;
  height: 100%;
}
::-webkit-scrollbar{
  width: 0;
  background-color: #F198A7;
}

  .el-input-group__prepend{
    min-width: 50px;
    text-align: center;
	}
  .el-form--label-top .el-form-item__label{
    padding: 0px;
  }
  .el-col{
    position: relative;
  }
body,html{
  height: 100%;
  width: 100%
}
.img-bg .el-input__inner {
    /* height: 36px; */
    color: #409fff;
    letter-spacing: 1px;
    border: 1px solid #cddff1;
}
.img-bg .el-input-group__append, .el-input-group__prepend {
    background-color: #e2ebf5;
    color: #409fff;
    padding: 0 8px;
}
.img-bg .login_btn .el-button--primary {
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    width: 100%;
    /* padding: 10px 20px; */
    letter-spacing: 10px;
}
.el-input__prefix, .el-input__suffix {
    /* color: #dfe6ec; */
    color: #409EFF;
}
.el-form-item {
    margin-bottom: 32px;
}
.font_bold{
  font-weight:bold;
}
/* 文字间隙 */
.letter_spac1{
  letter-spacing:1px
}
/* 文字划线 */
.text-dec{
  text-decoration:line-through
}
.font_14{
  font-size: 14px;
}
.font_16{
  font-size: 16px;
}
.font_18{
  font-size: 18px;
}
.font_19{
  font-size: 19px;
}
.font_20{
  font-size: 20px;
}
.font_22{
  font-size: 22px;
}
.font_24{
  font-size: 24px;
}
.font_30{
  font-size: 30px;
}
.color_red{
  color: #FC5623;
}
.color_gray{
  color: 	#A9A9A9;
}
.flex-between-center{
  display: flex;
  justify-content:space-between;
  align-items: center;
}



/* ----------------首页----------------- */
/* .el-dialog {
    height: 949px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue